import { FC } from 'react'
import { AppHead } from 'client/components/Layout/components/AppHead/AppHead'
import { SonarPageContent } from 'client/contents/SonarPageContent/SonarPageContent'

type TProps = {}

const SonarPage: FC<TProps> = () => {
  return (
    <article className="flex w-full flex-col bg-surface-white">
      <AppHead />
      <SonarPageContent />
    </article>
  )
}

export default SonarPage
